module.exports = __webpack_public_path__ + "images/questions/qa_lets_question_a441a60f06647c774ae1248dbfca5eab.png";